<template>
  <div class="toggle-switch" :class="{ disabled: disabled }">
    <label class="switch">
      <input
          type="checkbox"
          :checked="modelValue"
          :disabled="disabled"
          @input="onInput"
      />
      <span class="slider"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: "ToggleSwitch",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput(event) {
      if (this.disabled) {
        return;
      }
      this.$emit("update:modelValue", event.target.checked);
      this.$emit('change', this.value);
    }
  }
};
</script>

<style scoped>
.toggle-switch {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Alapértelmezés (főként mobilhoz) */
.switch {
  position: relative;
  display: inline-block;
  width: 66px;
  height: 38px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #DDE5EC;
  transition: 0.4s;
  border-radius: 20px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 30px;
  width: 30px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
}

input:checked + .slider {
  background-color: #B2EC5D;
}

input:checked + .slider:before {
  transform: translateX(28px);
}

/* desktop sizing */
@media (min-width: 992px) {
  .switch {
    width: 42px;
    height: 24px;
  }

  .slider {
    border-radius: 12px;
  }

  .slider:before {
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
  }

  input:checked + .slider:before {
    transform: translateX(18px);
  }
}

.disabled .slider {
  background-color: #e0e0e0;
  cursor: not-allowed;
}

.toggle-switch.disabled {
  opacity: 0.6;
}

.toggle-switch.disabled .slider {
  cursor: not-allowed;
}
</style>